import {
  DesaturateFilter,
  ImageScaleView,
  View,
  ViewOpts,
} from '@play-co/timestep-core/ui';

// This is not a typo, just couldn't find a better name (TeamChest's chest) for this component
export class TeamChestChest extends View {
  private chest: ImageScaleView;
  private filter: DesaturateFilter;

  constructor(opts: ViewOpts) {
    super({ ...opts, width: 290, height: 290 });

    this.filter = new DesaturateFilter(0);

    this.chest = new ImageScaleView({
      superview: this,
      width: this.style.width,
      height: this.style.height,
      image: 'assets/ui/match2/chest/team_closed.png',
      scaleMethod: 'contain',
      centerOnOrigin: true,
      filter: this.filter,
    });
  }

  public showOpened() {
    this.show();
    this.filter.update(0);
    this.chest.updateOpts({
      image: 'assets/ui/match2/chest/team_open.png',
    });
  }

  public showClosed() {
    this.show();
    this.filter.update(0);
    this.chest.updateOpts({
      image: 'assets/ui/match2/chest/team_closed.png',
    });
  }

  public showGreyed() {
    this.show();
    this.filter.update(1);
    this.chest.updateOpts({
      image: 'assets/ui/match2/chest/team_closed.png',
    });
  }
}
